import React from 'react';
import * as ReactDOM from 'react-dom';
import { call, put, select, takeEvery } from 'redux-saga/effects';

import Notification from '../../../components/Notification/Notification';

import axios from '../../../services/axios-client';

import * as HEALTH_TYPES from '../../actions/health/types';

import * as HEALTH_ACTIONS from '../../actions/health';

import * as AUTH_SELECTORS from '../../selectors/auth';

import { HTTP_METHOD } from '../../../const/http/HTTP_METHOD';
import { COMPANY_PAY_PRO_STATUS_ROUTE } from '../../../const/http/API_URL';
import { HTTP_STATUS_CODE } from '../../../const/http/HTTP_STATUS_CODE';

function* getPayProStatus() {
    const { companyKey } = yield select(AUTH_SELECTORS.authSelector);

    try {
        const res = yield call(axios.request, {
            method: HTTP_METHOD.GET,
            url: COMPANY_PAY_PRO_STATUS_ROUTE,
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                'company-api-key': companyKey,
            },
        });

        const { data: resData } = res;
        const { code, result } = resData;
        if (code === HTTP_STATUS_CODE.OK) {
            yield put(HEALTH_ACTIONS.setPayProStatus({ status: result }));
        }
    } catch (error) {
        ReactDOM.render(
            <Notification
                type='error'
                error={error}
            />,
            document.getElementById('notification'),
        );
    }
}

export const watchPayPro = [
    takeEvery(HEALTH_TYPES.PAY_PRO_STATUS_GET, getPayProStatus),
];
